"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResizeGroup = void 0;
var ResizeGroup_base_1 = require("./ResizeGroup.base");
exports.ResizeGroup = ResizeGroup_base_1.ResizeGroupBase;
//# sourceMappingURL=ResizeGroup.js.map